import { axios } from '@/lib/axios';
import { Details } from "@/containers/basicInfo/BasicInfoEdit";

export const getBasicData = () => {
  return axios.get(`/api/v1/customers/getMyPageBaseData`)
}
export const getBasicInfo = () => {
  return axios.get(`/api/v1/customers/getMyPageBaseInfo`)
}
export const updateBasicData = ( base_data: Details ): Promise<any> => {
  return axios.post(`/api/v1/customers/updateMyPageBaseData`, base_data)
}

export const getDrmBasicInfo = () => {
  return axios.get(`/api/v1/customers/getMyPageDrmPfBaseData`)
}

export const getDrmPfDocumentDownload = () => {
  return axios.get(`/api/v1/Customers/getDataDocuments`)
}